import {
  loadablePage as loadable,
  withDefaultLoaderModifiers,
} from "@gamedev-web/gamedev-sdk-core";

export const OrderConfirmationPage = loadable(() =>
  withDefaultLoaderModifiers(import("./OrderConfirmationPage"))
);
